export const PAGE_KEY = "page";
export const PER_PAGE = 8;